// Politique de mot de passe — même règle que le serveur (server/utils/password.js).
export const MDP_MIN = 12;

export const MDP_REGLES = [
  { key: 'long', label: `${MDP_MIN} caractères minimum`, test: (p) => p.length >= MDP_MIN },
  { key: 'maj', label: 'une majuscule', test: (p) => /[A-Z]/.test(p) },
  { key: 'min', label: 'une minuscule', test: (p) => /[a-z]/.test(p) },
  { key: 'chiffre', label: 'un chiffre', test: (p) => /[0-9]/.test(p) },
  { key: 'special', label: 'un caractère spécial (! ? @ # -…)', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const mdpConforme = (p) => MDP_REGLES.every(r => r.test(String(p || '')));

// Mot de passe provisoire robuste (sans caractères ambigus comme O/0 ou l/1).
export function genererMotDePasse() {
  const maj = 'ABCDEFGHJKLMNPQRSTUVWXYZ', min = 'abcdefghijkmnopqrstuvwxyz', chif = '23456789', spec = '!?@#-+*';
  const tout = maj + min + chif + spec;
  const rnd = (n) => { const a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] % n; };
  const pick = (s) => s[rnd(s.length)];
  const c = [pick(maj), pick(min), pick(chif), pick(spec)];
  while (c.length < 14) c.push(pick(tout));
  for (let i = c.length - 1; i > 0; i--) { const j = rnd(i + 1); [c[i], c[j]] = [c[j], c[i]]; }
  return c.join('');
}
